// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROLE_PROFESSOR } from '../constants/roles';

// Pages restées accessibles au joueur dont la ligue est terminée : accueil (message de fin de jeu)
// et profil (avec ses sous-pages de modification).
const ARCHIVED_ALLOWED_PATHS = ['/accueil', '/profil', '/modifie-nom-utilisateur', '/modifie-nom-equipe', '/modifie-mot-depasse', '/modifie-mot-de-passe'];

const PrivateRoute = ({ element }) => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const role = useSelector((state) => state.auth.user?.role);
    const leagueArchived = useSelector((state) => state.auth.user?.league_archived);
    const { pathname } = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/connexion" replace />;
    }

    // Les professeurs ont leur propre espace, distinct de l'application élève
    if (role === ROLE_PROFESSOR) {
        return <Navigate to="/espace-professeur/vue-ensemble" replace />;
    }

    // Ligue terminée : plus rien à faire à part consulter l'accueil et le profil
    if (leagueArchived && !ARCHIVED_ALLOWED_PATHS.includes(pathname)) {
        return <Navigate to="/accueil" replace />;
    }

    return element;
};

export default PrivateRoute;
